import ResponsiveHeader from '@/components/ResponsiveHeader';
import { resolveHeaderBack } from '@/lib/navigation';
import { Stack } from 'expo-router';

/**
 * Membership is a drill-in from Account, so it wears the same header as the
 * settings stack instead of drawing its own close control.
 */
export default function MembershipStackLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => {
          const { showBack, onBack } = resolveHeaderBack(navigation, back);
          return (
            <ResponsiveHeader
              title={(options.title as string) || ''}
              showBack={showBack}
              showBookmark={false}
              onBack={onBack}
              navItems={[
                { label: 'Explore', href: '/explore' },
                { label: 'Live', href: '/live' },
                { label: 'The Hang', href: '/library' },
              ]}
            />
          );
        },
      }}
    >
      <Stack.Screen name="index" options={{ title: '' }} />
    </Stack>
  );
}
